<template>
  <transition name="modal">
    <div class="modal fade show modal-mask" style="display:block" id="myModal" tabindex="-1" role="dialog">
      <div v-bind:class="[large ? 'modal-dialog modal-lg modal-dialog-centered' : '', 'modal-dialog']" role="document" v-bind:style="width ? { maxWidth: width + 'px' } : {}">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">
              <slot name="header">
                <i :class="element_list['icon']"></i>
                {{ element_list['title'] }}
              </slot>
            </h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('close')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="overflow-y: auto" :style="element_list['style']">
            <b-form v-if="tab_form">
              <b-tabs>
                <b-tab v-for="(tab, i) in tabs" :key="i" :active="i === 0">
                  <template v-slot:title>
                    <i class="tab.class"></i> {{ tab.name }}
                  </template>
                  <modal-elements :datetimeConfig="datetimeConfig" :element_list="element_list['segments'][i]['elements']" :elements="tab_values[i]"></modal-elements>
                </b-tab>
              </b-tabs>
            </b-form>
            <b-form v-else>
              <div v-for="(segment, i) in element_list['segments']" :key="i">
                <div v-if="element_list['segments'][i].hasOwnProperty('section_display') ? element_list['segments'][i]['section_display'] : true">
                  <br v-if="i > 0">
                  <div v-if="segment['header']">
                    <h5><i :class="segment['icon']"></i> {{ segment['title'] }}</h5>
                    <hr>
                  </div>
                  <modal-elements :datetimeConfig="datetimeConfig" :element_list="segment['elements']" :elements="elements"></modal-elements>
                </div>
              </div>
            </b-form>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <!--<button  v-for="el in elementListFilter(element_list['footer'])" :key="el.type" :type="el.type" :class="el.class" v-on:click="emit_function(el.onclick)" >{{ el.label }}</button>-->

              <button v-for="(el, i) in elementListFilter(element_list['footer'])" :key="i" v-on:click="emit_function(el.onclick)" :type="el.type" :class="buttonClass" :disabled="el.spinner">
                <span v-if="el.spinner" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                {{ el.label }}
              </button>
              <button type="button" class="btn btn-secondary" @click="$emit('close')">{{ $t('close') }}</button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>

import VSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component'
import { Turkish } from 'flatpickr/dist/l10n/tr.js'
import Api from '@/services/Api'
import ModalElements from '@/components/widgets/ModalElements'


export default {
  name: 'Modal',
  data() {
    return {
      elements: {},
      dateConfig: {
        time_24hr: false,
        dateFormat: 'j.m.Y',
        enableTime: false,
        altInput: true,
        altFormat: 'j.m.Y',
        locale: this.get_flactpickr_lang()
      },
      timeConfig: {
        dateFormat: 'H:i',
        altFormat: 'H:i',
        enableTime: true,
        noCalendar: true,
        altInput: true,
        locale: this.get_flactpickr_lang()
      },
      password_icon: false,
      main_users: []
    }
  },
  props: {
    large: {
      required: false,
      default: false
    },
    width: {
      required: false,
      type: Number
    },
    values: {
      required: false,
      type: Object
    },
    tab_values: {
      required: false,
      type: Array
    },
    element_list: {
      type: Object
    },
    tab_form: {
      default: false,
      type: Boolean
    },
    tabs: {
      type: Array,
      default: () => []
    },
    buttonClass: {
      type: String,
      default: 'btn btn-primary'
    },
    datetimeConfig: {
      required: false,
      type: Object,
      default: () => {
        return {
          dateFormat: "j.m.Y H:i",
          altFormat: "j.m.Y H:i",
          enableTime: true,
          altInput: true,
        }
      }
    }
  },
  methods: {
    get_flactpickr_lang() {
      if (this.$store.getters.lang === 'en') {
        return null
      } else if (this.$store.getters.lang === 'tr') {
        return Turkish
      }
    },
    elementListFilter(elementList) {
      return elementList.filter(el => el.type === 'button')
    },
    emit_function(click) {
      this.$emit(click, this.elements)
    },
    change_icon(segment, segmentIndex, elementIndex) {
      this.password_icon = !this.password_icon
      if (this.password_icon) {
        segment['elements'][elementIndex]['type'] = 'text'
      } else {
        segment['elements'][elementIndex]['type'] = 'password'
      }
    },
    changeFile(e) {
      console.log(e)
    }
  },
  components: {
    flatPickr,
    'v-select': VSelect,
    ModalElements
  },
  mounted() {
    let self = this
    self.elements = self.values ? self.values : self.tab_values
    Api.post(this, 'ats/get_main_users').then(response => {
      self.main_users = response
      if (self.elements.groups && self.elements.groups !== '' && self.elements.groups.label === 'sub_user') {
        self.element_list.segments.map(s => {
          s.elements.map(function (x) {
            if (x.model === 'parent_user') {
              x.hidden = false
              x.options = self.main_users
            }
          })
        })
      }
    })
  },
  computed: {
    groups() {
      return this.elements.groups
    }
  },
  watch: {
    groups(val) {
      let self = this
      if (val && val !== '' && val.label === 'sub_user') {
        self.element_list.segments.map(s => {
          s.elements.map(function (x) {
            if (x.model === 'parent_user') {
              x.hidden = false
              x.options = self.main_users
            }
          })
        })
      } else if (val.label === 'sub_user') {
        //işlevsiz if statement
      } else {
        self.element_list.segments.map(s => {
          s.elements.map(function (x, index) {
            if (x.model === 'parent_user') {
              x.hidden = true
            }
          })
        })
      }
    }
  }
}
</script>

<style type="text/css" scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.center {
  text-align: center;
}
</style>
